<div class="blur-content">
    <div class="page-container" style="background-color: #f2f8fa !important">
      <app-sidebar-menu [selected]="selected" [isAdmin]="true"></app-sidebar-menu>
      <div class="main-content">
        <app-header></app-header>
        <div class="main-content-inner">
          <div class="row mt-5">
            <div
              class="col-12"
              style="padding-right: 0 !important; margin-right: 0 !important"
            >
              <div class="card">
                <div class="card-body">
                  <div *ngIf="errorMessage" class="alert alert-danger d-flex align-items-center justify-content-between">
                    <p class="flex-grow-1">{{ errorMessage }}</p>
                    <button class="btn btn-primary" (click)="refreshClients()">Retry</button>
                  </div>
                  <app-table *ngIf="!errorMessage"
                    [tableHeader]="[
                      'Id',
                      'First Name',
                      'Last Name',
                      'Company Name',
                      'Job Title',
                      'Mobile',
                      'Email',
                      'Status'
                    ]"
                    [tableRows]="[
                      'id',
                      'firstName',
                      'lastName',
                      'companyName',
                      'jobTitle',
                      'mobile',
                      'email',
                      'status'
                    ]"
                    [data]="clients"
                    [page]="page"
                    [pageSize]="pageSize"
                    [pageSizeOptions]="pageSizeOptions"
                    [collectionSize]="collectionSize"
                    [model]="model"
                    [refreshData]="refreshClients"
                    [openViewModel]="openViewModel"
                    [loading]="loading"
                    [isView]="true"
                    [isSearch]="true"
                    [title]="'Client Search'"
                  ></app-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  